import { jsx as o } from "react/jsx-runtime";
import { k as r } from "./react-toastify.esm.js";
function i() {
  return /* @__PURE__ */ o(r, {});
}
export {
  i as T
};
